import * as React from 'react'
import styled from '@emotion/styled'
//import EasyBooking from "./BookingText";
require('../../styles/global.css');
import  {Dates} from "./BookingDates";
//import StudioPlx from "../swipesliders/StudioPlx";
//import { FormattedMessage } from 'react-intl';



const StyledBookingText = styled.div`
  width: 80%;
display: flex;
justify-content: space-between;
margin-left:auto;
margin-right:auto;
align-items:center;
font-family: "Theano Didot", Regular;
color:rgb(68, 68, 68);
//background-color:rgba(144, 144, 144,.04);

float:left;
padding-top:20px;

  @media screen and (max-width: 1200px) {
text-align:center;
float:none;
width:100%;
display:block;
   }


`;





const EasyDiv = styled.div`
width:100%;
margin-top:1.3%;

`



interface BookingTextProps {
  className?: string
  locale?: string
}

const Booking: React.FC<BookingTextProps> = ({locale }) => (
  <StyledBookingText>

<EasyDiv>
<Dates locale={locale} />

</EasyDiv>
  </StyledBookingText>

)

export default Booking
